<template>
  <div class="terms">
    <div class="terms__hero"></div>
    <div class="document">
      <h1>마케팅 정보 수신 동의</h1>

      <p>
        혜움은 개인정보 보호법 및 정보 통신망 이용 촉진 및 정보 보호 등에 관한
        법률 등 관계 법령에 따라 광고성 정보를 전송하기 위해 수신자의 사전 수신
        동의를 받고 있습니다.
      </p>

      <h3>1. 이용 항목 및 목적</h3>
      <ul>
        <li>
          추천 서비스, 할인 혜택, 이벤트 정보 등 광고성 정보를 제공하기 위해
          고객의 휴대전화 번호와 이메일 주소를 사용합니다.
        </li>
      </ul>

      <h3>2. 전송 방법</h3>
      <ul>
        <li>혜움 서비스 화면, Email 등을 통해 전달될 수 있습니다.</li>
      </ul>

      <h3>3. 전송 내용</h3>
      <ul>
        <li>
          세무 관련 정보, 각종 혜택(할인, 이벤트 등), 혜움 이용을 권유하는
          내용(추천 서비스, 새로운 기능 또는 제품 안내) 등 광고성 정보가
          발송됩니다. 단, 결제 안내 등 의무적으로 안내되어야 하는 정보는 수신
          동의 여부와 무관하게 제공됩니다.
        </li>
      </ul>

      <h3>4. 철회 안내</h3>
      <ul>
        <li>
          수신 동의 이후 언제라도 동의를 철회할 수 있으며, 수신에 동의하지
          않으셔도 혜움이 제공하는 기본적인 서비스를 이용할 수 있습니다. 단,
          할인이나 이벤트, 추천 서비스 등 마케팅 정보 안내 서비스는 제한됩니다.
        </li>
      </ul>

      <h3>5. 수신 동의 변경</h3>
      <ul>
        <li>
          혜움 서비스 화면이나 고객센터(1644-5060)를 통해 수신 동의를
          변경(동의/철회)하실 수 있습니다.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfMarketing',
  head: {
    title: '마케팅 정보 수신 동의 - 세무법인혜움'
  },
  layout: 'invert-font-header'
}
</script>

<style scoped lang="scss"></style>
